import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import AddAlertForm from "../../components/alerts/AddForm";
import { Container, Button, Row, Col, Modal } from "react-bootstrap";

import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";
import PaginationTable from "../../components/common/Table";
import { useParams } from "react-router-dom";

const AlertsList = () => {
  const [tableData, setTableData] = useState([]);
  const [title, setTitle] = useState("Filtri");
  const formRef = useRef<any>();
  const [isModalOpen, setOpenModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [alert, setAlert] = useState({
    id: null,
    make: "",
    model: "",
    yearFrom: 0,
    yearTo: 0,
    priceFrom: 0,
    priceTo: 0,
    kilometersFrom: 0,
    kilometersTo: 0,
    alertChannelId: "",
  });
  const { isAuthenticated } = useAuth();
  let { listId } = useParams();

  const currencyFormatter = new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });

  const numberFormatter = new Intl.NumberFormat("sl-SI", {
    maximumFractionDigits: 0,
  });

  let tableColumns = [
    {
      listIds: [1, 2, 3],
      Header: "Znamka",
      accessor: "make",
    },
    {
      listIds: [1, 2],
      Header: "Model",
      accessor: "model",
    },
    {
      listIds: [3],
      Header: "Opis",
      accessor: (d: any) => {
        if (!d.title) {
          return d.model;
        }

        return d.title;
      },
    },
    {
      listIds: [1, 2, 3],
      Header: "Letnik Od",
      accessor: "yearFrom",
    },
    {
      listIds: [1, 2, 3],
      Header: "Letnik Do",
      accessor: "yearTo",
    },
    {
      listIds: [1, 2],
      Header: "Kilometri Od",
      accessor: (d: any) => {
        if (!d.kilometersFrom) {
          return "/";
        }

        return numberFormatter.format(d.kilometersFrom);
      },
    },
    {
      listIds: [1, 2],
      Header: "Kilometri Do",
      accessor: (d: any) => {
        if (!d.kilometersTo) {
          return "/";
        }

        return numberFormatter.format(d.kilometersTo);
      },
    },
    {
      listIds: [3],
      Header: "Ure Od",
      accessor: (d: any) => {
        if (!d.kilometersFrom) {
          return "/";
        }

        return numberFormatter.format(d.kilometersFrom);
      },
    },
    {
      listIds: [3],
      Header: "Ure Do",
      accessor: (d: any) => {
        if (!d.kilometersTo) {
          return "/";
        }

        return numberFormatter.format(d.kilometersTo);
      },
    },
    {
      listIds: [1, 2, 3],
      Header: "Cena Od",
      accessor: (d: any) => {
        if (!d.priceFrom) {
          return "/";
        }

        return currencyFormatter.format(d.priceFrom);
      },
    },
    {
      listIds: [1, 2, 3],
      Header: "Cena Do",
      accessor: (d: any) => {
        if (!d.priceTo) {
          return "/";
        }

        return currencyFormatter.format(d.priceTo);
      },
    },
    {
      listIds: [1, 2, 3],
      Header: "Obveščanje",
      accessor: (d: any) => {
        if (d.alertChannel && d.alertChannel.id) {
          return d.alertChannel.type;
        }

        return "";
      },
    },
    {
      listIds: [1, 2, 3],
      Header: " ",
      accessor: (d: any) => {
        return (
          <Button
            variant="outline-secondary"
            className="float-end"
            onClick={() => {
              setAlert(d);
              toggle();
            }}
          >
            Uredi
          </Button>
        );
      },
    },
  ];

  tableColumns = tableColumns.filter((col) =>
    col.listIds.includes(parseInt(listId || "0"))
  );

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    setIsLoading(true);
    axios
      .get("/alerts/list/" + listId)
      .then((response) => {
        setTableData(response.data.alerts);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });

    if (listId === "2") {
      setTitle("Filtri za tovorna vozila");
    } else if (listId === "3") {
      setTitle("Filtri za delovne stroje");
    } else {
      setTitle("Filtri za osebna vozila");
    }
  }, [isAuthenticated, listId]);

  const toggle = (reload = false) => {
    setOpenModal(!isModalOpen);

    if (reload) {
      axios
        .get("/alerts/list/" + listId)
        .then((response) => setTableData(response.data.alerts));
    }
  };

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const removeAlert = () => {
    axios
      .delete("/alerts/" + alert.id)
      .then((response) => toggle(true))
      .catch((e) => console.error(e));
  };

  return (
    <React.Fragment>
      <Helmet title="Obveščanje" />
      <Container fluid className="p-0">
        <Row>
          <Col>
            <h1 className="h3 mb-3">{title}</h1>
          </Col>
          <Col>
            <Button
              variant="outline-primary"
              onClick={() => {
                setAlert({
                  id: null,
                  make: "",
                  model: "",
                  yearFrom: 0,
                  yearTo: 0,
                  priceFrom: 0,
                  priceTo: 0,
                  kilometersFrom: 0,
                  kilometersTo: 0,
                  alertChannelId: "",
                });
                toggle();
              }}
              className="float-end"
            >
              <i className="bi bi-plus-circle"></i>
              &nbsp; Dodaj
            </Button>
          </Col>
        </Row>
        <PaginationTable
          toggle={toggle}
          setAlert={setAlert}
          isLoading={isLoading}
          columns={tableColumns}
          data={tableData}
          paginationEnabled={false}
        />
      </Container>

      <Modal show={isModalOpen} onHide={() => toggle()}>
        <Modal.Header closeButton>
          <Modal.Title>
            {alert.id ? "Uredi filter" : "Dodaj filter"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3">
          <AddAlertForm
            listId={listId}
            formRef={formRef}
            toggle={toggle}
            alert={alert}
          />
        </Modal.Body>
        <Modal.Footer>
          <Container>
            <Row className="d-flex">
              {alert.id ? (
                <Col className="text-start">
                  <Button variant="outline-danger" onClick={removeAlert}>
                    Odstrani
                  </Button>
                </Col>
              ) : (
                ""
              )}
              <Col className="text-end">
                <Button variant="primary" onClick={submitForm}>
                  Shrani
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AlertsList;
